export const CONFIGURE= "CONFIGURE";
export const NOTIFY= "NOTIFY";
export const CLOSE= "CLOSE";